module.exports = __webpack_public_path__ + "static/media/zebra03.64e71a9d.png";